import React, { useState, useEffect } from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload } from "@fortawesome/pro-solid-svg-icons"
import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next"

const DownloadsBlock = ({ block }) => {
  const [gscConsentState, setgscConsentState] = useState(false)

  const { t, i18n } = useTranslation()

  useEffect(() => {
    setTimeout(() => {
      if (typeof window.gsc !== "undefined") {
        setgscConsentState(true)
      }
    }, 1000)
  }, [])

  const getFileName = (file) => {
    if (file) {
      let fileName = file.split("/")
      fileName = fileName[fileName.length - 1]
      return fileName
    }
  }

  const getFileExtension = (file) => {
    if (file) {
      let fileType = file.split(".")
      fileType = fileType[fileType.length - 1]
      fileType = fileType.toUpperCase()
      return fileType
    }
  }

  return (
    <>
      <Helmet>
        <script
          type="text/plain"
          data-name="getsitecontrol"
          data-type="application/javascript"
        >
          {` window.gsc=window.gsc||function(){(gsc.q=gsc.q||[]).push(arguments)}; `}
        </script>
      </Helmet>
      <BlockWrapper
        block={block}
        blockWidth="content"
        blockDirection="horizontal"
        showHeadline="true"
        className="bg-gray-100"
      >
        {block.download_items?.length > 0 &&
          block.download_items.map((item, index) => (
            <React.Fragment key={index}>
              {item.gsc_id?.length > 0 ? (
                <>
                  {gscConsentState ? (
                    <button
                      onClick={() => window.gsc("show", item.gsc_id)}
                      className="block py-4 border-b-2 border-gray-300 text-primary hover:text-primary-hover"
                    >
                      <div className="flex flex-row" key={index}>
                        <div className="flex">
                          <FontAwesomeIcon
                            icon={faDownload}
                            size="1x"
                            className="mt-1.5 mr-4"
                          />
                        </div>
                        <div className="text-left">
                          <span className="block text-lg font-bold">
                            {item.title?.length > 0 && item.title}
                          </span>
                          <span className="inline-block prose">
                            {item.manual_filetype?.length > 0 && (
                              <>
                                {item.manual_filetype.toUpperCase()}
                                <br />
                              </>
                            )}
                            {item.description?.length > 0 && (
                              <>{item.description}</>
                            )}
                          </span>
                        </div>
                      </div>
                    </button>
                  ) : (
                    <div className="py-4 border-b-2 border-gray-300">
                      <div className="flex flex-row" key={index}>
                        <div className="flex">
                          <FontAwesomeIcon
                            icon={faDownload}
                            size="1x"
                            className="mt-1.5 mr-4"
                          />
                        </div>
                        <div className="text-left">
                          <span className="block text-lg font-bold">
                            {item.title?.length > 0 && item.title}
                          </span>
                          <span className="inline-block prose">
                            {t("gsc-downloads.start")}{" "}
                            <b>{t("gsc-downloads.consent")}</b>{" "}
                            {t("gsc-downloads.middle")}{" "}
                            <button
                              className="font-bold text-primary hover:text-primary-hover"
                              onClick={(e) => {
                                e.preventDefault()
                                window.klaro.show(window.klaroConfig)
                              }}
                            >
                              {t("gsc-downloads.cookie-consent")}
                            </button>{" "}
                            {t("gsc-downloads.end")}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <Link
                  key={index}
                  className="block py-4 border-b-2 border-gray-300 text-primary hover:text-primary-hover"
                  link={item.file.filename}
                >
                  <div className="flex flex-row" key={index}>
                    <div className="flex">
                      <FontAwesomeIcon
                        icon={faDownload}
                        size="1x"
                        className="mt-1.5 mr-4"
                      />
                    </div>
                    <div className="text-left">
                      <span className="block text-lg font-bold">
                        {item.title?.length > 0
                          ? item.title
                          : getFileName(item.file.filename)}
                      </span>
                      <span className="inline-block prose">
                        {getFileExtension(item.file.filename)}
                        {item.description?.length > 0 && (
                          <>
                            <br />
                            {item.description}
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </Link>
              )}
            </React.Fragment>
          ))}
        {/* {gscConsentState && (
          <button onClick={() => window.gsc("show", 407711)}>GSC Test</button>
        )} */}
      </BlockWrapper>
    </>
  )
}

export default DownloadsBlock
